export default __webpack_public_path__ + "static/media/mockup-calendar-presentation.d8a5b1b0.png";